export default [{
  name: 'lucash',
  namespaced: true,
  state: {
    model: {
      selecionado: {},
      Pessoa: {
        PF: {},
        PJ: {},
        TipoPessoa: null,
        PessoaDadosContato: {},
        PessoaDadoFinanceiro: {},
        PessoaEndereco: {},
        PessoaQualificacao: {},
      },
      PropostaDadosVeiculo: {}
    }
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        selecionado: {},
        Pessoa: {
          PF: {},
          PJ: {},
          TipoPessoa: null,
          PessoaDadosContato: {},
          PessoaDadoFinanceiro: {},
          PessoaEndereco: {},
          PessoaQualificacao: {}
        },
        PropostaDadosVeiculo: {}
      }
      commit('model', data)
    },
    beforeEach ({ getters, commit }, { to, from, next }) {
      switch (to.fullPath) {
        case '/':
          if (localStorage.ambiente) { next({ path: '/partner/' + localStorage.ambiente }) }
          break;
      }
    }
  },
  logoutFunctions: {
    // beforeClear(state) {
    //  console.log('a')
    // },
    afterClear (state) {
      location.href = '/partner/' + state.empresa.ambiente
    },
  }
}]
